import { FC } from 'react';
import classes from '../../asset/css/pickup/pickup-shipping-product-list.module.css';
import { ProductInfoViewType } from '../../types/view/product-info-view-type';
import { PickupProductItem } from './PickupProductItem';

export const PickupShippingProductList: FC<{
  products: ProductInfoViewType[];
  loading: boolean;
  cancelSubscriptionFunc: (lineId?: string) => void;
  updateQuantityFunc: (lineId: string, quantity: number) => void;
  setChangeDeliveryDateModalFunc: (changeDeliveryDateModalActive: boolean) => void;
}> = ({ products, loading, cancelSubscriptionFunc, updateQuantityFunc, setChangeDeliveryDateModalFunc }) => {
  if (products.length === 0) {
    return <></>;
  }

  return (
    <div className={classes.pickup}>
      <div className={classes.pickup_header}>
        <h1 className={classes.pickup_header_heading}>MY BOXの商品変更</h1>
      </div>

      <div className={classes.pickup_products}>
        <div className={classes.pickup_products_header}>
          <h2 className={classes.pickup_products_header_heading}>PRODUCTS</h2>
          <p className={classes.pickup_products_desc}>画像タップで商品詳細が確認できます。</p>
        </div>
        <ul className={classes.pickup_products_list}>
          {products.map((product, index) => (
            <PickupProductItem
              key={`pickupProductItem_${index}`}
              loading={loading}
              productItem={product}
              cancelSubscriptionFunc={cancelSubscriptionFunc}
              updateQuantityFunc={updateQuantityFunc}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};
